"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchFlowsBase = void 0;
var patchWorkspacesRequestF_1 = require("./patchWorkspacesRequestF");
var patchInviteRequestF_1 = require("./patchInviteRequestF");
var patchWorkspaceUserRequestDelayF_1 = require("./patchWorkspaceUserRequestDelayF");
var patchCustomClaimSuccessF_1 = require("./patchCustomClaimSuccessF");
// order doesnt matter
exports.patchFlowsBase = [
    patchCustomClaimSuccessF_1.patchCustomClaimSuccessF,
    patchWorkspacesRequestF_1.patchWorkspacesRequestF,
    patchInviteRequestF_1.patchInviteRequestF,
    patchWorkspaceUserRequestDelayF_1.patchWorkspaceUserRequestDelayF,
];
